<template>
    <div class="evaluate">
        <div class="evaluate-box">
            <div class="evaluate-tit">
                <span class="evaluate-tit-line"></span>
                <span class="evaluate-tit-bold">全部评价</span>
            </div>

            <div class="evaluate-info">
                <div class="evaluate-info-box" v-show="evaluate.length">
                    <div class="evaluate-info-list"
                         v-for="(item,index) in evaluate"
                         :key="index"
                    >
                        <div class="evaluate-from-team" v-show="item.level == 2">
                            <div class="team-img">
                                <img :src="item.headUrl" alt="">
                            </div>
                            <div class="team-right">
                                <p class="team-name-time">
                                    {{ item.company_name }} 回复了您的评价 {{ item.created_at }}
                                </p>
                                <p class="team-reply-content">
                                    {{ item.content2 }}
                                </p>
                            </div>
                        </div>

                        <div class="evaluate-from-me">
                            <p class="me-evaluate">
                                {{ item.content }}
                            </p>
                            <div class="me-evaluate-team">
                                <div class="me-evaluate-team-title">
                                    {{ item.title }}
                                </div>
                                <div class="all-evaluate-team">
                                    {{ item.all_comments }} 条评论
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no-evaluate-info" v-show="!evaluate.length">
                    <img :src="noEvaluate" alt="">
                    <span>您还没有评价过哦</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "evaluate",
        data() {
            return {
                evaluate: [],
                noEvaluate: require('@/assets/images/persondata/null_img_pjlt.png'),
            }
        },
        mounted() {
            this.getEvaluate();
        },
        methods: {
            getEvaluate() {
                var that = this;
                var index;
               /* layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/
                that.$axios.get('/commentReply', {}).then((res) => {
                    // layer.closeAll();
                    res = res.data;
                    if (res.status == 200) {
                        that.evaluate = res.data;
                    } else {
                        // layer.msg(res.msg, {icon: 2});
                        this.$message(res.msg);
                    }
                }).catch((error) => {
                    // layer.closeAll();
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
    .evaluate {
        width: 998px;
        border: 1px solid #EEEEEE;
    }

    .evaluate-box {
        width: 958px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }

    .evaluate-tit {
        height: 49px;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .evaluate-tit-line {
        width: 2px;
        height: 14px;
        background: #FF5227;
    }

    .evaluate-tit-bold {
        margin-left: 10px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .evaluate-info {
        width: 950px;
    }

    .evaluate-info-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .evaluate-info-list {
        width: 100%;
        padding: 20px 0;
    }

    .evaluate-from-team {
        display: flex;
        flex-direction: row;
    }

    .team-img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
    }

    .team-img img {
        width: 100%;
        height: 100%;
    }

    .team-right {
        margin-left: 12px;
        width: 880px;
    }

    .team-name-time {
        height: 20px;
        line-height: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .team-reply-content {
        width: 100%;
        line-height: 18px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
    }

    .evaluate-from-me {
        margin-left: 58px;
        margin-top: 16px;
        padding-left: 14px;
        border-left: 4px solid #eee;
    }

    .me-evaluate {
        width: 870px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .me-evaluate-team {
        width: 870px;
        background: #F8F8F8;
        border-radius: 4px;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
    }

    .me-evaluate-team-title {
        width: 600px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 10px 0 6px 6px;
    }

    .all-evaluate-team {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999;
        margin: 0 0 10px 6px;
    }

    /*暂无评价*/
    .no-evaluate-info {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
    }

    .no-evaluate-info img {
        width: 280px;
        height: 236px;
        margin-top: 30px;
    }

    .no-evaluate-info span {
        width: 182px;
        height: 24px;
        line-height: 24px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        margin-bottom: 20px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/evaluate.vue